<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 text-sm p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">คิวส่งบัตรไป Taiwan</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        บัตรที่ยังไม่มี mapping Taiwan — เลือกแล้วกดส่ง (สูงสุด {{ maxSend }} ใบ/ครั้ง)
      </p>
      <div class="flex flex-wrap items-center gap-2 mt-3">
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
        <span *ngIf="taiwanSite"
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-sky-50 dark:bg-sky-900/20 text-sky-700 dark:text-sky-300 text-xs font-bold">
          <span class="material-icons text-[14px]">flag</span> taiwan_site
        </span>
        <span *ngIf="taiwanSite && !hasTaiwanUrl"
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-rose-50 dark:bg-rose-900/20 text-rose-600 dark:text-rose-300 text-xs font-bold">
          <span class="material-icons text-[14px]">link_off</span> ไม่มี taiwan_url
        </span>
        <span *ngIf="selectedSiteId && !taiwanSite && !isLoading"
          class="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-500 text-xs font-bold">
          <span class="material-icons text-[14px]">info</span> ลานนี้ไม่ใช่ Taiwan site — ไม่มีคิวให้ส่ง
        </span>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
      <div *ngIf="lastFetchedAt" class="flex flex-col items-end text-right">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none">{{ lastFetchedAt | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center h-[46px] cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
    </div>
  </div>

  <!-- Selection / Send bar -->
  <div class="animate-fade-in mb-6 rounded-3xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)]">
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div>
        <p class="text-sm font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">checklist</span>
          เลือกแล้ว {{ selectedCount | number }} / {{ maxSend }} ใบ
        </p>
        <p class="text-xs text-slate-400 mt-1.5 font-medium">
          หลังส่งสำเร็จและมี mapping แล้ว บัตรจะหายจากหน้ารายการนี้
        </p>
      </div>
      <div class="flex flex-wrap items-stretch sm:items-center gap-3">
        <button type="button" (click)="clearSelection()" *ngIf="selectedCount > 0"
          class="px-5 py-3 h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-500 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 transition-all cursor-pointer">
          ล้างการเลือก
        </button>
        <button *ngIf="canUpdate" type="button" (click)="onSendClick()" [disabled]="!canSendSelected"
          class="px-6 py-3 h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none disabled:opacity-50 transition-all cursor-pointer inline-flex items-center justify-center gap-2 border-none">
          <span class="material-icons text-[18px]">send</span>
          {{ isSending ? 'กำลังส่ง...' : 'ส่ง Taiwan ที่เลือก' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Table card -->
  <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
    style="animation-delay: 0.1s;">
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">send</span>
        รายการรอส่ง Taiwan
      </h3>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
        <div class="relative w-full sm:w-80">
          <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px] pointer-events-none">search</span>
          <input type="text" [(ngModel)]="searchText" (keyup.enter)="onSearch()"
            placeholder="ค้นหา card_code / ชื่อ / ทะเบียน / uid..."
            class="w-full pl-10 pr-4 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm rounded-xl font-medium outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 h-[46px] text-slate-700 dark:text-slate-200 placeholder:text-slate-400" />
        </div>
        <button type="button" (click)="onSearch()"
          class="px-5 h-[46px] rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-none transition-all cursor-pointer border-none inline-flex items-center justify-center gap-2">
          <span class="material-icons text-[18px]">search</span>
          ค้นหา
        </button>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] h-[520px] relative custom-scrollbar"
      [class.opacity-50]="isLoading || isSending">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">
            <th class="p-5 w-[56px]">
              <input type="checkbox" [checked]="allPageSelected"
                (change)="toggleSelectAllPage(($any($event.target)).checked)"
                [disabled]="!selectedSiteId || rows.length === 0 || !taiwanSite"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 accent-amber-500 focus:ring-amber-400 cursor-pointer disabled:opacity-40" />
            </th>
            <th class="p-5">หมายเลขบัตร</th>
            <th class="p-5">ชื่อ</th>
            <th class="p-5">ทะเบียน</th>
            <th class="p-5">Client</th>
            <th class="p-5">เริ่มสิทธิ์</th>
            <th class="p-5">หมดอายุ</th>
            <th class="p-5">สถานะบนบัตร</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngIf="!selectedSiteId && !isLoading">
            <td colspan="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40">location_off</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">กรุณาเลือกลานจาก Sidebar</p>
              </div>
            </td>
          </tr>
          <tr *ngFor="let row of rows" class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200">
            <td class="p-5">
              <input type="checkbox" [checked]="isSelected(row.id)"
                (change)="toggleRow(row.id, ($any($event.target)).checked)"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 accent-amber-500 focus:ring-amber-400 cursor-pointer" />
            </td>
            <td class="p-5 font-mono font-bold text-slate-700 dark:text-slate-200">{{ row.cardCode || '—' }}</td>
            <td class="p-5 font-semibold text-slate-700 dark:text-slate-200">{{ row.name || '—' }}</td>
            <td class="p-5 text-slate-600 dark:text-slate-300">{{ row.licensePlate || '—' }}</td>
            <td class="p-5 text-slate-600 dark:text-slate-300">{{ row.clientName || '—' }}</td>
            <td class="p-5 tabular-nums text-slate-600 dark:text-slate-300">{{ row.issueDate | date:'dd/MM/yyyy':'':'en-GB' }}</td>
            <td class="p-5 tabular-nums text-slate-600 dark:text-slate-300">{{ row.expireDate | date:'dd/MM/yyyy':'':'en-GB' }}</td>
            <td class="p-5">
              <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold border"
                [ngClass]="row.taiwanSyncStatus
                  ? 'bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800'
                  : 'bg-slate-50 dark:bg-slate-800 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700'">
                {{ row.taiwanSyncStatus || 'ยังไม่เคยส่ง' }}
              </span>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading && rows.length === 0">
            <td colspan="8" class="py-20 text-center">
              <div class="flex flex-col items-center justify-center text-slate-400">
                <span class="material-icons text-4xl mb-2 opacity-40">{{ taiwanSite ? 'search_off' : 'block' }}</span>
                <p class="font-bold text-slate-700 dark:text-slate-200">
                  {{ taiwanSite ? 'ไม่พบบัตรค้างส่ง' : 'ไม่ใช่ลาน Taiwan' }}
                </p>
                <span class="text-sm mt-1" *ngIf="taiwanSite">ทุกบัตรมี mapping แล้ว หรือไม่ตรงเงื่อนไขค้นหา</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }} รายการ</span>
        <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)"
          class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
          <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage - 1)" [disabled]="currentPage <= 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer border-none"
          [ngClass]="p === currentPage
            ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none'
            : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ p }}
        </button>
        <button type="button" (click)="setPage(currentPage + 1)" [disabled]="currentPage >= totalPages || totalPages === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal
  *ngIf="isConfirmOpen"
  [title]="'ส่งบัตรไป Taiwan?'"
  [message]="'ส่งบัตรที่เลือก'"
  [highlight]="confirmHighlight"
  [messageSuffix]="'ไประบบใต้หวัน — หลังสำเร็จจะหายจากคิวนี้'"
  [confirmLabel]="'ส่ง Taiwan'"
  [icon]="'send'"
  [variant]="'warning'"
  [showIrreversibleNote]="false"
  (confirm)="confirmSend()"
  (cancel)="closeConfirm()">
</app-pss-confirm-modal>

<app-pss-loading *ngIf="isLoading || isSending"></app-pss-loading>
